import { Button } from '~/components/ui/button';

interface AssistantErrorMessageProps {
  /** Human-readable failure reason from the error block (server message or FE-synthesized). */
  message: string;
  /** Retry handler — wired only when the turn is retryable. */
  onRetry?: (() => void) | undefined;
  /**
   * When `false`, the failure is deterministic (bad model config / auth) — the
   * Retry button is hidden because replaying the same request would just fail
   * again. Defaults to retryable.
   */
  retryable?: boolean | undefined;
}

/** Inline card for a failed Q&A turn — renders in place of the assistant bubble, with a Retry button only when the error is retryable. */
export function AssistantErrorMessage({
  message,
  onRetry,
  retryable = true,
}: AssistantErrorMessageProps) {
  return (
    // role=alert so assistive tech announces the failure when the turn errors.
    <div role="alert" className="border-error/30 bg-error-50 space-y-2 rounded-xl border p-3">
      <p className="text-foreground text-sm font-medium">Lily couldn&apos;t answer that.</p>
      <p className="text-muted-foreground text-xs leading-5 break-words">{message}</p>
      {retryable && onRetry ? (
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-7 cursor-pointer text-xs"
          onClick={onRetry}
        >
          Retry
        </Button>
      ) : null}
    </div>
  );
}
